import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { BasicInfoTab, GeneralTab, ObjectTab, OtherTab } from './tabs';
import { useBangKeHoaDonBanHangContext } from '../context';
import { SearchFormValues, searchSchema } from '../schema';
import { useSearchFieldStates } from '../hooks';

interface InitialSearchDialogProps {
  onClose: () => void;
  onSearch: (values: SearchFormValues) => Promise<void>;
  initialValues: SearchFormValues;
}

export default function SearchDialog({ onClose, onSearch, initialValues }: InitialSearchDialogProps) {
  const searchFieldStates = useSearchFieldStates();
  const { state } = searchFieldStates;
  const { setExportSubtitle } = useBangKeHoaDonBanHangContext();

  const handleSubmit = (data: SearchFormValues) => {
    const formatLabel = (value?: string) => {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const formattedFrom = formatLabel(data.ngay_ct1 || '');
    const formattedTo = formatLabel(data.ngay_ct2 || '');
    setExportSubtitle(formattedFrom && formattedTo ? `Từ ngày ${formattedFrom} đến ngày ${formattedTo}` : '');

    const combinedData: SearchFormValues = {
      ...data,
      ngay_ct1: data.ngay_ct1,
      ngay_ct2: data.ngay_ct2,
      // Customer/Supplier related
      ma_nv: state.nhanVien?.uuid || '',
      ma_kh: state.khachHang?.uuid || '',
      nh_kh1: state.nhomKhachHang1?.uuid || '',
      nh_kh2: state.nhomKhachHang2?.uuid || '',
      nh_kh3: state.nhomKhachHang3?.uuid || '',
      rg_code: state.khuVuc?.uuid || '',

      // Item related
      ma_vt: state.vatTu?.uuid || '',
      ma_lvt: state.loaiVatTu?.uuid || '',
      nh_vt1: state.nhomVatTu1?.uuid || '',
      nh_vt2: state.nhomVatTu2?.uuid || '',
      nh_vt3: state.nhomVatTu3?.uuid || '',
      ma_kho: state.khoHang?.uuid || '',

      // Object tab fields
      ma_bp: state.boPhan?.uuid || '',
      ma_vv: state.vuViec?.uuid || '',
      ma_hd: state.hopDong?.uuid || '',
      ma_dtt: state.dotThanhToan?.uuid || '',
      ma_ku: state.kheUoc?.uuid || '',
      ma_phi: state.phi?.uuid || '',
      ma_sp: state.sanPham?.uuid || '',
      ma_lsx: state.lenhSanXuat?.uuid || '',
      ma_cp0: state.chiPhi?.uuid || '',

      // Other tab fields
      ma_gd: state.giaoDich?.uuid || '',
      tk_vt: state.taiKhoanVatTu?.uuid || '',
      tk_dt: state.taiKhoanDoanhThu?.uuid || '',
      tk_gv: state.taiKhoanGiaVon?.uuid || '',
      ma_lo: state.lo?.uuid || '',
      ma_vi_tri: state.viTri?.uuid || ''
    };
    onSearch(combinedData);
  };

  const tabs = [
    {
      id: 'general',
      label: 'Thông tin chung',
      component: <GeneralTab searchState={searchFieldStates} />
    },
    {
      id: 'object',
      label: 'Đối tượng',
      component: <ObjectTab searchState={searchFieldStates} />
    },
    {
      id: 'other',
      label: 'Khác',
      component: <OtherTab searchState={searchFieldStates} />
    }
  ];

  return (
    <DialogV2
      open={true}
      onClose={onClose}
      title='Bảng kê hóa đơn bán hàng, dịch vụ'
      titleIcon={<AritoIcon icon={699} />}
      maxWidth='lg'
    >
      <div className='flex size-full flex-col overflow-hidden'>
        <div className='max-h-[calc(100vh-120px)] flex-1 overflow-auto'>
          <AritoFormV2<SearchFormValues>
            schema={searchSchema}
            initialData={initialValues}
            onSubmit={handleSubmit}
            className='!static !w-full'
            hasAritoActionBar={false}
            headerFields={
              <div className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'>
                <BasicInfoTab />

                <HeaderTabsV2 tabs={tabs} />
              </div>
            }
            bottomBar={<BottomActionBarV2 mode='search' onClose={onClose} />}
          />
        </div>
      </div>
    </DialogV2>
  );
}
